import {
    type AddCouponToMyListMutationVariables,
    type CouponContentResponse,
    CouponWidgetContentDocument,
    type CouponWidgetContentQueryVariables,
    useAddCouponToMyListMutation,
    useCouponWidgetContentQuery,
    useGetAppliedUniversalCodesLazyQuery,
    useGetAppliedUniversalCodesQuery,
} from '../../types/front.graphql';

export const useStoreCouponToWallet = () => {
    const [storeCouponToWallet, { data, loading, error }] = useAddCouponToMyListMutation();

    const addCouponToWallet = async (variables: AddCouponToMyListMutationVariables) => {
        try {
            const response = await storeCouponToWallet({
                fetchPolicy: 'no-cache',
                variables,
                refetchQueries: [CouponWidgetContentDocument],
                awaitRefetchQueries: true,
            });

            return response?.data;
        } catch {
            return undefined;
        }
    };

    return {
        addCouponToWallet,
        status: data?.addCouponToMyList,
        loading,
        error,
    };
};

export const useCouponWidgetContent = (variables?: CouponWidgetContentQueryVariables, skip?: boolean) => {
    const { data, loading, error, refetch, networkStatus } = useCouponWidgetContentQuery({
        fetchPolicy: 'cache-and-network',
        variables,
        skip: !variables || skip,
        notifyOnNetworkStatusChange: true,
    });

    const couponContent = (data?.couponWidgetContent as CouponContentResponse[]) ?? null;

    return {
        couponContent,
        loading,
        error,
        refetch,
        networkStatus,
    };
};

export const useGetAppliedCoupons = (variables?: { cartId: string }) => {
    const { data, loading, error, refetch } = useGetAppliedUniversalCodesQuery({
        fetchPolicy: 'no-cache',
        variables,
        skip: !variables,
    });
    return {
        appliedCoupons: data?.cart?.applied_universal_codes ?? [],
        loading,
        error,
        refetch,
    };
};

export const useGetAppliedCouponsLazy = () => {
    const [fetchCoupons, { data, loading, error }] = useGetAppliedUniversalCodesLazyQuery({
        fetchPolicy: 'no-cache',
    });

    const appliedCoupons = data?.cart?.applied_universal_codes ?? [];

    return {
        fetchCoupons,
        appliedCoupons,
        loading,
        error,
    };
};
